import { render, staticRenderFns } from "./Fontfamily.vue?vue&type=template&id=30970ae7&"
import script from "./Fontfamily.vue?vue&type=script&lang=js&"
export * from "./Fontfamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports